import React from "react";
import {IonProgressBar} from "@ionic/react";
import {LojaObject} from "../../models/Loja";
import FieldView from "../../components/FieldView";
import EntityView from "../../components/EntityView";
import FormLoja, {formDef} from "./FormLojaHOC";
import fb from "../../lib/firebase";
import {actions} from "../../lib/app";
import {AppDispatch, RootState} from "../../global.state";
import {connect} from "react-redux";
import {dataInCurrentMonth} from "../../lib/utils";

interface Props {
  instance: LojaObject;
  goBack: () => void;
  loading: boolean;
  dispatch: AppDispatch;
}

interface State {
  allowDelete: boolean;
}

class AbaLoja extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      allowDelete: dataInCurrentMonth(props.instance.criado_em.toDate()),
    }
  }

  componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any) {
    if (prevProps.instance.criado_em !== this.props.instance.criado_em) {
      this.setState({allowDelete: dataInCurrentMonth(this.props.instance.criado_em.toDate())});
    }
  }

  onDelete = () => {
    fb.db.collection('lojas').doc(this.props.instance.id).delete()
      .then(() => {
        this.props.dispatch(actions.notifySuccess('Loja excluída com sucesso.'));
        this.props.goBack();
      });
  };

  render() {
    const {instance} = this.props;

    if (this.props.loading)
      return <IonProgressBar type="indeterminate"/>;

    return (
      <EntityView
        instance={this.props.instance}
        ModelForm={FormLoja}
        entityLabel="Loja"
        gender="f"
        allowDelete={this.state.allowDelete}
        onDelete={this.onDelete}
      >
        <FieldView def={formDef.nome} value={instance.nome} className="text-2xl"/>
        <FieldView def={formDef.cnpj} value={instance.cnpj}/>

        <div className="flex flex-wrap">
          <div className="w-8/12">
            <FieldView def={formDef.cidade} value={instance.cidade}/>
          </div>
          <div className="w-4/12">
            <FieldView def={formDef.estado} value={instance.estado}/>
          </div>
        </div>
        <div className="flex flex-wrap">
          <div className="w-8/12">
            <FieldView def={formDef.proprietario} value={instance.proprietario}/>
          </div>
          <div className="w-4/12">
            <FieldView def={formDef.gerente} value={instance.gerente}/>
          </div>
        </div>
        {
          instance.balconista_lider &&
          <FieldView def={formDef.balconista_lider} value={instance.balconista_lider}/>
        }
        {
          instance.telefone &&
          <FieldView def={formDef.telefone} value={instance.telefone}/>
        }
        {
          instance.email &&
          <FieldView def={formDef.email} value={instance.email}/>
        }

        <div className="flex flex-wrap">
          <div className="w-8/12">
            <FieldView def={formDef.endereco} value={instance.endereco}/>
          </div>
          <div className="w-4/12">
            <FieldView def={formDef.complemento} value={instance.complemento}/>
          </div>
        </div>

        <FieldView def={formDef.cep} value={instance.cep}/>
      </EntityView>
    )
  }
}

export default connect(({app}: RootState) => ({app}))(AbaLoja);
